import Splide from '@splidejs/splide';

const EL = '.js-eshop';

document.querySelectorAll('.js-eshop').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: false,
    gap: 40,
    perPage: 3,
    breakpoints: {
      1366: {
        gap: 20,
      },
      1024: {
        perPage: 2,
        pagination: true,
      },
      767: {
        gap: 10,
        fixedWidth: '310px',
        perPage: 1,
      },
    },
  });

  slider.mount();
});
